import * as React from 'react';

import { getField } from 'src/utils/EntryUtil';
import { Blurb } from '../Contentful/Blurb';
import { useProgramPromotion } from '../ProgramPromotion/ProgramPromotion';
import { useSalesChannel } from '../SalesChannel/SalesChannel';

export const TermsAndConditions: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => {
  const { salesChannel } = useSalesChannel();
  const { programPromotion } = useProgramPromotion();

  if (!salesChannel) return null;

  return (
    <div className={className} {...props}>
      {!programPromotion && (
        <Blurb
          entry={getField(salesChannel, 'currentPromotion')}
          field="detailsAndLegal"
        />
      )}
      <Blurb
        entry={salesChannel}
        field="legalDisclosureFooterBlurb"
      />
    </div>
  );
};
